import { render } from "./bookingDetailComponent.vue?vue&type=template&id=3c037128&scoped=true"
import script from "./bookingDetailComponent.vue?vue&type=script&lang=js"
export * from "./bookingDetailComponent.vue?vue&type=script&lang=js"

import "./bookingDetailComponent.vue?vue&type=style&index=0&id=3c037128&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c037128"]])

export default __exports__